import React from 'react';
import style from './MasProductosSS.module.css';

import imagen1 from '../../../../utils/images/box-7.png';
import imagen2 from '../../../../utils/images/box-8.png';
import imagen3 from '../../../../utils/images/box-9.png';
import { Link } from 'react-router-dom';

const MasProductosSS = ({ t }) => {
  return (
    <div className={style.container}>
      {/*<p className={style.titulo}>{t('Products.SupervisionAndControlSystem.More-products.title')}</p>*/}

      <div className={style.productos}>
        <Link to="/productos/smartsen" className={style.link}>
          <div className={style.item}>
            <p className={style.nombre}>{t('HomePage.Products.Smartsen')}</p>
            <img src={imagen1} alt={t('HomePage.Products.smartsen')} className={style.imagen} />            
          </div>
        </Link>

        <Link to="/productos/smartssc" className={style.link}>
          <div className={style.item}>
            <p className={style.nombre}>{t('HomePage.Products.SmartSSC')}</p>
            <img src={imagen3} alt={t('HomePage.Products.SmartSSC')} className={style.imagen} />
          </div>
        </Link>
        
        <Link to="/productos/smartiot" className={style.link}>
          <div className={style.item}>
            <p className={style.nombre}>{t('HomePage.Products.smartiot')}</p>
            <img src={imagen2} alt={t('HomePage.Products.smartiot')} className={style.imagen} />
          </div>
        </Link>

      </div>
    </div>
  );
};

export default MasProductosSS;
